import { Box, Typography } from '@mui/material';

import { DEFAULT_CURRENCY } from 'constants/tickets.constants';

import EventListItem from 'components/@events/EventListItem';
import FormattedMoneyInfo from 'components/@tickets/FormattedMoneyInfo';

import { EnrichedOrder } from './types';

const Order = ({ title, cover, itemsCount, totalPrice }: EnrichedOrder) => {
  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <EventListItem.Cover cover={cover} />
      <EventListItem.Content sx={{ flexGrow: 1 }}>
        <EventListItem.Title>{title}</EventListItem.Title>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              flexGrow: '1',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography
              variant="extraSmall"
              fontWeight="bold"
              color="global01.400"
            >
              <FormattedMoneyInfo
                price={{ amount: totalPrice, currency: DEFAULT_CURRENCY }}
              />
            </Typography>
          </Box>
          <EventListItem.TicketsIndicator quantity={itemsCount} />
        </Box>
      </EventListItem.Content>
    </Box>
  );
};

export default Order;
